<template>
  <div>
    <v-dialog v-model="dialog" width="750" persistent>
      <v-card>
        <v-card-title class="redColor">
          <span class="headline text-white">{{
            $t("parts.inventory.sell_multiple")
          }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container grid-list-md>
              <v-row>
                <v-col>
                  <div>
                    <v-chip
                      v-for="part in partsToSell"
                      :key="part._id"
                      closable
                      color="green-darken-2"
                      class="ma-1"
                      @click:close="removePart(part)"
                    >
                      {{ part.old_id.slice(-6) }}
                    </v-chip>
                  </div>
                </v-col>

                <!------------------------------------CLIENTS ROW------------------------------------>
                <v-col
                  v-if="
                    $store.getters.role !== 'User' &&
                    $store.getters.role !== 'EbayOperator'
                  "
                  cols="12"
                  xs="12"
                  md="12"
                  lg="12"
                >
                  <v-row>
                    <v-col xs="6" sm="8" md="8">
                      <v-autocomplete
                        v-model="client"
                        :items="clients"
                        :label="$t('parts.inventory.actions.select_client')"
                        :rules="rules.requiredSelect"
                        color="red-darken-1"
                        :item-title="clientDisplayTitle"
                        :custom-filter="clientAutocompleteFilter"
                        item-value="_id"
                        prepend-icon="mdi-account"
                        return-object
                        autocomplete="off"
                        clearable
                      />
                    </v-col>
                    <v-col cols="12" xs="6" sm="4" md="4">
                      <v-btn
                        color="success"
                        class="mt-3 px-2"
                        @click="addClient"
                      >
                        {{ $t("parts.inventory.actions.add_client") }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col
                  v-if="
                    $store.getters.role !== 'User' &&
                    $store.getters.role !== 'EbayOperator'
                  "
                  xs="12"
                  cols="12"
                >
                  <v-textarea
                    v-model="notes"
                    outlined
                    label="Notes"
                    color="red-darken-2"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="red-darken-1" variant="outlined" @click="close">
            {{ $t("parts.inventory.actions.cancel") }}
          </v-btn>
          <v-btn
            :disabled="
              !valid ||
              (client &&
                typeof client === 'object' &&
                Object.keys(client).length < 1)
            "
            :loading="loading"
            color="green"
            variant="outlined"
            @click="sell"
          >
            {{ $t("parts.inventory.actions.sell") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="responseModal" persistent width="400">
      <v-card class="pa-3">
        <div v-for="(item, index) in multipleResponse" :key="index">
          <v-alert
            :model-value="true"
            variant="tonal"
            border="bottom"
            :type="item.error ? 'error' : 'success'"
          >
            <strong>
              {{ item.error ? item.error : $t("sent_to_sales") }}</strong
            >
          </v-alert>
        </div>
        <v-card-actions class="col-12 justify-end mt-2">
          <v-btn small variant="outlined" @click="closeResponseModal()">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="errorModal" persistent width="400">
      <v-card class="pa-3">
        <v-alert :value="true" type="error" variant="tonal" border="bottom">
          <strong> {{ errorMsg }}</strong>
        </v-alert>
        <v-card-actions class="col-12 justify-end mt-2">
          <v-btn small variant="outlined" @click="closeErrorModal()">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import getRequest from "../../api/getRequest";
import postRequest from "../../api/postRequest";
import {
  clientAutocompleteFilter,
  clientDisplayTitle,
} from "../../utils/clientDisplay";

export default {
  data: () => ({
    dialog: false,
    valid: false,
    loading: false,
    confirm: false,
    part: {},
    parts: null,
    partsPrice: null,
    partsToSell: [],
    sale: {
      part: {},
      client: {},
    },
    client: {},
    clients: [],
    cash: 0,
    notes: "",
    rules: {
      requiredLetters: [
        (v) => !!v || "Please fill this field",
        (v) => /[A-Za-z]/.test(v) || "Only letters are allowed",
      ],
      requiredNumbers: [
        (v) => !!v || "Please fill this field",
        (v) => /[0-9]/.test(v) || "Only numbers are allowed",
      ],
      requiredSelect: [(v) => (v && !!v.name) || "Item is required"],
    },
    responseModal: false,
    multipleResponse: [],
    errorModal: false,
    errorMsg: "",
  }),
  computed: {
    difference() {
      if (this.cash - this.part.price >= 0) {
        const difference = (this.cash - this.part.price).toString();
        const trimedNumber = difference.substring(0, 6);
        return trimedNumber;
      }
      const difference = (this.part.price - this.cash).toString();
      const trimedNumber = difference.substring(0, 6);
      return trimedNumber;
    },
  },
  watch: {
    client(value) {
      if (value && typeof value === "object" && Object.keys(value).length < 1) {
        this.sale.client_id = value._id;
        this.sale.client.name = value.name;
        this.sale.client.surname = value.surname;
        this.sale.client.email = value.email;
        this.sale.client.phone = value.phone;
      }
    },
  },
  methods: {
    clientDisplayTitle,
    clientAutocompleteFilter,
    open(data) {
      this.getClients();
      this.partsToSell = data.map((p) => ({
        _id: p._id,
        old_id: p.old_id,
        price: p.price,
      }));
      this.dialog = true;
    },
    removePart(part) {
      this.partsToSell = this.partsToSell.filter((p) => p._id !== part._id);
    },
    close() {
      this.dialog = false;
      this.part = {};
      this.parts = null;
      this.partsPrice = null;
      this.sale = {
        part: {},
        client: {},
      };
      this.confirm = false;
      this.cash = 0;
      this.notes = "";
      this.client = {};
      this.clients = [];
      this.loading = false;
      this.partsToSell = [];
      // this.$emit('close');
    },
    async sell() {
      this.loading = true;
      const partsPayload = this.partsToSell.map((p) => ({
        part_id: p._id,
        price: p.price,
      }));
      postRequest
        .object("/sale/new-multiple", {
          client_id: this.client._id,
          user_id: this.$store.getters.userId,
          notes: this.notes,
          parts: partsPayload,
        })
        .then((response) => {
          this.loading = false;
          // Each response item looks like:
          // { part_id, response: [ ... , { ebayError }, { googleMerchantError } ] }
          this.multipleResponse = response.data;
          this.responseModal = true;
          this.$emit(
            "sold-items",
            this.partsToSell.map((p) => p._id),
          );
          this.partsToSell = [];
          this.close();
          this.$emit("close");
        })
        .catch((error) => {
          if (error && error.response && error.response.data) {
            this.errorMsg = error.response.data;
            this.errorModal = true;
            this.partsToSell = [];
          }
          this.loading = false;
          this.close();
          this.$emit("close");
        });
    },
    closeResponseModal() {
      this.multipleResponse = [];
      this.responseModal = false;
    },
    closeErrorModal() {
      this.errorMsg = "";
      this.errorModal = false;
    },
    getFirstEbayItemId() {
      const listings = this.part.eBayListings;
      if (!listings || typeof listings !== "object") return null;
      for (const country in listings) {
        if (Array.isArray(listings[country]) && listings[country].length > 0) {
          return listings[country][0]; // return the first item ID found
        }
      }
      return null; // No item found
    },
    async sellEbay() {
      this.loading = true;
      const firstItemId = await this.getFirstEbayItemId();
      postRequest
        .object("/ebay/sell-on-ebay", {
          eBayItemId: firstItemId,
        })
        .then((response) => {
          this.loading = false;
          const ebayErrorObject = response.data.find((item) => item.ebayError);
          if (
            ebayErrorObject &&
            ebayErrorObject.ebayError &&
            ebayErrorObject.ebayError != null
          ) {
            this.$emit("show-error-modal", ebayErrorObject.ebayError);
          }
          this.close();
          this.$emit("close");
        })
        .catch(() => {
          this.loading = false;
          this.close();
          this.$emit("close");
        });
    },
    searchClient(search) {
      getRequest(
        "/client/search",
        `search=${search}&role=${
          this.$store.getters.role
        }&institution_id=${this.$store.getters.institutionId}`,
      )
        .then(() => {})
        .catch(() => {});
    },
    getClients() {
      getRequest(
        "/client/",
        `role=${this.$store.getters.role}&institution_id=${
          this.$store.getters.institutionId
        }`,
      )
        .then((response) => {
          this.clients = response.clients;
        })
        .catch(() => {});
    },
    addClient() {
      this.$emit("add-client");
    },
    hide() {
      this.dialog = false;
    },
    show() {
      this.dialog = true;
    },
  },
};
</script>
